import React, { useState, useEffect } from "react";
import { useSellerAuth } from "../../context/SellerAuthContext";
import { useNavigate } from "react-router-dom";
import { auth } from "../../services/firebase";
import {
  PhoneAuthProvider,
  RecaptchaVerifier,
  signInWithCredential,
} from "firebase/auth";

const PhoneInputStep = () => {
  const { registrationData, setRegistrationData } = useSellerAuth();
  const [phoneNumber, setPhoneNumber] = useState(
    registrationData.phoneNumber || ""
  );
  const [verificationId, setVerificationId] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!window.recaptchaVerifier) {
      window.recaptchaVerifier = new RecaptchaVerifier(
        auth,
        "recaptcha-container",
        {
          size: "invisible",
          callback: (response) => {
            console.log("reCAPTCHA verified!", response);
          },
          "expired-callback": () => {
            console.log("reCAPTCHA expired. Please try again.");
          },
        }
      );

      window.recaptchaVerifier
        .render()
        .catch((err) => console.error("reCAPTCHA error:", err));
    }
  }, []);

  const handleSendCode = async () => {
    try {
      if (!phoneNumber.startsWith("+")) {
        setError(
          "Phone number must start with country code (e.g., +233XXXXXXXXX)."
        );
        return;
      }

      const provider = new PhoneAuthProvider(auth);
      const verificationId = await provider.verifyPhoneNumber(
        phoneNumber,
        window.recaptchaVerifier
      );

      setVerificationId(verificationId);
      setIsCodeSent(true);
      setRegistrationData({ ...registrationData, phoneNumber });
      setError(""); // Clear errors

      console.log("Verification code sent.");
    } catch (error) {
      console.error("Error sending verification code:", error.message);
      setError(error.message);
    }
  };

  const handleVerifyCode = async () => {
    try {
      if (!verificationCode) {
        setError("Please enter the verification code.");
        return;
      }

      const credential = PhoneAuthProvider.credential(
        verificationId,
        verificationCode
      );
      await signInWithCredential(auth, credential);

      console.log("Phone verification successful!");
      navigate("/register/mobile-money");
    } catch (error) {
      console.error("Error verifying the code:", error.message);
      setError("Invalid verification code. Please try again.");
    }
  };

  return (
    <div className="p-4 max-w-md mx-auto bg-white rounded-lg shadow-md">
      <h1 className="text-xl font-semibold text-gray-700">
        Enter Your Phone Number
      </h1>
      <input
        type="tel"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        className="w-full p-2 mt-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Enter phone number (e.g., +233XXXXXXXXX)"
      />

      {/* reCAPTCHA container (must be present before calling verifyPhoneNumber) */}
      <div id="recaptcha-container"></div>

      {error && <p className="text-red-500 mt-2">{error}</p>}

      {!isCodeSent ? (
        <button
          onClick={handleSendCode}
          className="mt-4 w-full p-2 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded"
        >
          Send Verification Code
        </button>
      ) : (
        <div>
          <h1 className="text-xl mt-4 font-semibold text-gray-700">
            Enter the verification code
          </h1>
          <input
            type="text"
            value={verificationCode}
            onChange={(e) => setVerificationCode(e.target.value)}
            className="w-full p-2 mt-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter code"
          />
          <button
            onClick={handleVerifyCode}
            className="mt-4 w-full p-2 bg-green-500 hover:bg-green-600 text-white font-semibold rounded"
          >
            Verify Code
          </button>
        </div>
      )}
    </div>
  );
};

export default PhoneInputStep;
